import { fetcher } from "services/api.service";
import { User } from "types/user";
import useSWRImmutable from "swr/immutable";

export default function useUsers(isAccountRep: boolean = false) {
  const { data, isLoading } = useSWRImmutable<{ users: User[] }>(
    `/users?filter[]=is_account_rep,is,${isAccountRep}`,
    fetcher,
  );

  return {
    users: data?.users || [],
    isLoading,
  };
}
